import './FilterOverviewItem.scss';
import template from './FilterOverviewItem.vhtml';

export default {
	name: 'FilterOverviewItem',
	template: template,
	props: {
		itemData: {
			type: Object,
			default: () => {},
		}
	},
	data: () => ({
		show: true,
	}),
	computed: {},
	methods: {},
};
